interface IconBadgeProps {
    count: number | string;
    icon?: string;
    className?: string;
}

export const IconBadge = ({ count, icon, className = '' }: IconBadgeProps) => {
    return (
        <div className={`px-2 py-1 bg-white/5 rounded-full inline-flex justify-start items-center gap-2 ${className}`}>
            <div className="justify-start text-xs font-bold font-montserrat leading-4">
                {count}
            </div>
            {icon && (
                <div className="w-4 h-4 relative overflow-hidden">
                    <img src={icon} alt="icon" className="w-4 h-4" />
                </div>
            )}
        </div>
    );
};
